import { NewIcon } from '../shared/icon';

export const ThreatIssueIcon = () => {
  return (
    <NewIcon
      iconClass='material-symbols-gpp-maybe-outline-rounded'
      color='var(--mui-palette-error-main)'
    />
  );
};
